import { render, staticRenderFns } from "./BeneficiaryAccountsTable.vue?vue&type=template&id=8e7431a4&scoped=true"
import script from "./BeneficiaryAccountsTable.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccountsTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=8e7431a4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7431a4",
  null
  
)

export default component.exports